export default [
  {
    path: "/website/deep-profile",
    name: "websiteDeepList",
    component: () => import(
      /*webpackChunkName:'website'*/
      "@/views/website/WebsiteDeepProfileList.vue"),
    meta: {}
  },
  {
    path: "/website/deep-task-result",
    name: "websiteDeepTaskResult",
    component: () => import(
      /*webpackChunkName:'website'*/
      "@/views/website/WebsiteDeepTaskResult.vue"),
    meta: {},
  },
  {
    path: "/website/wide-profile",
    name: "websiteWideList",
    component: () => import(
      /*webpackChunkName:'website'*/
      "@/views/website/WebsiteWideProfileList.vue"),
    meta: {}
  },
  {
    path: "/website/wide-task-result",
    name: "websiteWideTaskResult",
    component: () => import(
      /*webpackChunkName:'website'*/
      "@/views/website/WebsiteWideTaskResult.vue"),
    meta: {},
  },
  {
    path: "/website/issues",
    name: "websitesIssues",
    component: () => import(
      /*webpackChunkName:'website'*/
      "@/views/website/WebsiteIssues.vue"),
    meta: {},
  },
  {
    path: "/website",
    name: "website",
    component: () => import(
      /*webpackChunkName:'website'*/
      "@/views/website/Website.vue"),
    meta: {},
  },
]